const debugStyles = 'color: gray';
const errorStyles = 'color: crimson';
const infoStyles = 'color: cadetblue';
const warningStyles = 'color: amber';
const successStyles = 'color: aquamarine';

const env = process.env.NEXT_PUBLIC_ENV;

export const logger = class {
	static log = (title, ...data) => {
		if (env === 'production') return;
		return console.log(title, ...data);
	};

	static debug = (title, ...data) => {
		if (env === 'production') return;
		return console.debug(`%c${title}`, debugStyles, ...data);
	};

	static info = (title, ...data) => {
		if (env === 'production') return;
		return console.info(`%c${title}`, infoStyles, ...data);
	};

	static success = (title, ...data) => {
		if (env === 'production') return;
		return console.info(`%c${title}`, successStyles, ...data);
	};

	static warn = (title, ...data) => {
		return console.warn(`%c${title}`, warningStyles, ...data);
	};

	static error = (title, ...data) => {
		return console.error(`%c${title}`, errorStyles, ...data);
	};
};

// Docs:
// https://developer.mozilla.org/en-US/docs/Web/API/Console
